import { createContext } from '@lit/context';
export const authenticationContext = createContext('authentication');
